import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login/index.vue'
import Home from '@/views/Home/index.vue'
Vue.use(Router)

let router_children = require.context('@/router/modules/', true, /^([\s\S])+\.route\.js$/);

let childrenArray= [];
router_children.keys().map(function(key) {
	 childrenArray=childrenArray.concat(router_children(key).default);
});


let routArr=[{
			path: '/login',
			name: 'Login',
			component: Login,
		},
		{
			path: '/',
			name: 'Home',
			component: Home,
			children: childrenArray
		},

	];


//let singlepage_children = require.context('@/router/singlepage/', true, /^([\s\S])+\.route\.js$/);
// singlepage_children.keys().map(function(key) {
//	 routArr=routArr.concat(singlepage_children(key).default);
//});
const router = new Router({
//	mode: 'history',
	base: process.env.BASE_URL,
	routes: routArr
});
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js